import { redirect } from 'react-router'
import { createBrowserRouter } from 'react-router-dom'
import TermsModal from 'src/components/join/TermsModal'
import Complete from 'src/pages/complete'
import Empty from 'src/pages/Empty'
import { IntroPage } from 'src/pages/Intro'
import Join from 'src/pages/join'
import Layout from 'src/pages/layout'

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        element: <Join />,
        path: '/mkt01/:pcode',
        children: [
              {
                path: ':telecom',
                element: <Join />,
                loader: ({ params }) => {
                  const paramCheck = !!params.telecom && ['0', '1', '2'].includes(params.telecom)

                  if (paramCheck) return true
                  else {
                    const redirectUrl = !!params.pcode ? `/join/${params.pcode}` : '/join'
                    return redirect(redirectUrl)
                  }
                },
              },
            ],
      },
      { element: <Complete />, path: 'complete', children: [{ path: ':jobStatus' }] },
    ],
  },
  { element: <TermsModal />, path: '/terms/:telecom/:termsIDX/:termsOrderIdx' },
  { element: <IntroPage />, path: '/webview/intro/:pcode' },
  { path: '*', element: <Empty /> },
])
